module.exports = __webpack_public_path__ + "static/img/10.f78e128.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/eng/10.png
// module id = 4EeO
// module chunks = 0